import _ from 'lodash'

export type PromiseType<T, K> = (arg: K[]) => Promise<T>

export function batchProxy<T, K>(fn: PromiseType<T, K>, delay = 1000) {
    const cache: K[] = []
    let timer: any
    let promise: Promise<T>
    return (codes: K[]) => {
        cache.push(...codes)
        if (timer) {
            return promise
        }
        promise = new Promise<T>((resolve, reject) => {
            timer = setTimeout(() => {
                fn(_.cloneDeep(cache))
                    .then(resolve)
                    .catch(reject)
                clearTimeout(timer as number)
                timer = null
                cache.length = 0
            }, delay)
        })
        return promise
    }
}